import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";
import { useLoader } from "../context/LoaderContext";
import { useMobile } from "../hooks/custom/useMobile";

const Loader = () => {
  const { loading } = useLoader();
  const { companyDetailsData } = useCompanyDetailsContext();
  const isMobile = useMobile();
  return (
    <>
      {loading && (
        <div className="preloader">
          {companyDetailsData.length > 0 ? (
            <img
              className="preloader__image"
              width={`${isMobile ? '250' : '350'}`}
              height={`${isMobile ? '100' : '200'}`}
              src={`${process.env.REACT_APP_cmsUrl}/uploads/${companyDetailsData[0]?.primary_logo_color[0]?.media?.name}`}
              alt="loader-logo"
            />
          ) : (
            <div className="static-loader"></div>
          )}
        </div>
      )}
    </>
  );
};

export default Loader;
